import { createContext } from "react"

export const AdminFocusedSurfaceContext = createContext(false)
